import * as React from 'react';

function Golf(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.23 8.115a5.12 5.12 0 01-5.115 5.115A5.12 5.12 0 017 8.115 5.109 5.109 0 0112.115 3a5.109 5.109 0 015.115 5.115zm-7.084 6.082l1.073 3.041V21h1.793v-3.762l1.09-3.04h-3.956z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Golf;
